import { lazy, Suspense } from 'react'

const WorkoutsPage = lazy(async () => {
  const module = await import('@/features/workouts/WorkoutsPage')
  return { default: module.WorkoutsPage }
})

const WorkoutFormPage = lazy(async () => {
  const module = await import('@/features/workouts/WorkoutForm')
  return { default: module.WorkoutFormPage }
})

function WorkoutRouteFallback() {
  return <p role="status">正在加载页面…</p>
}

export function WorkoutsRoute() {
  return <Suspense fallback={<WorkoutRouteFallback />}><WorkoutsPage /></Suspense>
}

export function WorkoutFormRoute() {
  return <Suspense fallback={<WorkoutRouteFallback />}><WorkoutFormPage /></Suspense>
}
